import React, { useState,useEffect } from "react";
import gift from "assets/img/gift image.png";
import steel from "assets/img/steel.png";
import chart from "assets/img/chart.png";
import logo from "assets/img/henry-schein-logo-png-transparent.png";
import sidelogo from "assets/img/HS_Thrive Unlocked__Lockup.png";
import unlock from "assets/img/HS_Thrive Unlocked__K.O.png";
import unlocked from "assets/img/unlocked.png";

import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { toast } from "react-toastify";
import upgardeloyalty from "apis/UpgradeLoyalty/upgardeloyalty";

import ThriveUnlockedStatus from "./ThriveUnlockedStatus";
import ThriveUnlockedReview from "./ThriveUnlockedReview";
import ThriveUnlockedStatusEligibility from "./ThriveUnlockedEligibility";
import ThriveUnlockedEligibilityReview from "./ThriveUnlockedEligibilityReview";
import ThriveUnlockedExist from "./ThriveUnlockedExist";
import ThriveUnlockedNotEligibility from "./ThriveUnlockedNotEligibility";
import ThriveUnlockedPending from "./ThriveUnlockedPending";
// import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import useTracking, { trackLead } from "helpers/useTracking";


export default function ThriveUnlocked() {
  const [showDetails, setShowDetails] = useState(false);
  const [shipto, setShipto] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [termlink, setTermlink] = useState("");
  const {
    getLinks
  } = upgardeloyalty();

  



  useEffect(() => {
      const fetchLinks = async () => {
        try {
          const response = await getLinks({ country: "us" });
          const linksData = response?.data || {};
          setTermlink(linksData.thriveunlockenroll);
         
        
        } catch (error) {
          console.error(error);
        }
      };
    
      fetchLinks(); // <--- important!
    }, []);
    
useTracking();
  const [data, setdata] = useState({
    practiceName: "",
    unlocklink: "",
  });

  const { getunlockedDetail } = upgardeloyalty();

  const handleSearch = async () => {
    if (!shipto) {
      return toast.error("Please enter the account number");
    }
  
    try {
      setLoading(true);
  
      let values = {
        shipto: shipto,
      };
  
      let res = await getunlockedDetail(values);
  
      if (res.result_status == 0) {
        if (res?.unlock_status == "enrolled") {
          setMessage("5");
             // Meta Lead event
    trackLead();
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }

         
        if (res?.unlock_status == "pending") {
          setMessage("7");
             // Meta Lead event
    trackLead();
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }
  
        if (res?.unlock_status == "noteligible") {
          setMessage("6");
             // Meta Lead event
    trackLead();
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }
  
        if (
          res.message == "Please enter a valid Location Account Number"
        ) {
          toast.error(res.message);
        }
         if (
          res.message == "This account is currently inactive and is not eligible for enrollment"
        ) {
          toast.error(res.message);
        }
      }
  
      if (res.result_status == 1) {
        if (res?.data?.unlock_status == "Unlocked") {
          setdata({
            practiceName: res?.data?.practice_name,
            unlocklink: res?.data?.thriveunlockLink,
          });
   // Meta Lead event
    trackLead();

          setMessage("1");
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }
  
        if (res?.data?.unlock_status == "Eligibility") {
          setdata({
            practiceName: res?.data?.practice_name,
            unlocklink: res?.data?.thriveunlockLink,
          });
   // Meta Lead event
    trackLead();
          setMessage("2");
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  localStorage.setItem("shipto", shipto);
  localStorage.setItem("practicename", data?.practiceName);
  localStorage.setItem("unlocklink", data?.unlocklink);

  if (message === "1") {
    return <ThriveUnlockedReview setNext={setMessage} />;
  }

  if (message === "2") {
    return <ThriveUnlockedEligibilityReview setNext={setMessage} />;
  }

  if (message === "3") {
    return <ThriveUnlockedStatus setNext={setMessage} />;
  }

  if (message === "4") {
    return <ThriveUnlockedStatusEligibility setNext={setMessage} />;
  }

  if (message === "5") {
    return <ThriveUnlockedExist setNext={setMessage} />;
  }

  if (message === "6") {
    return <ThriveUnlockedNotEligibility setNext={setMessage} />;
  }

  if (message === "7") {
    return <ThriveUnlockedPending setNext={setMessage} />;
  }

  return (
    <>
      <style>{mobileCss}</style>

      <div style={styles.page}>
        {/* HEADER */}
        <div style={styles.fullHeader}>
          <div style={styles.headerContent}>
            <img src={logo} alt="logo" style={styles.logo} />

            <img
              src={sidelogo}
              alt="side-logo"
              style={styles.rightLogo}
            />
          </div>
        </div>

        {/* CARD */}
        <div style={styles.card}>
          {/* TOP BLUE HEADER */}
          <div style={styles.cardHeader}>
            <img src={unlock} alt="unlock" style={styles.unlockLogo} />
          </div>

          {/* CONTENT */}
          <div style={styles.content}>
            <img
              src={unlocked}
              alt="unlock"
              style={styles.iconCircle}
            />

            <h2 style={styles.title}>
            You’ve Been Selected  <br /> 
            </h2>

             <div style={styles.valueText}>
              <span>$0 enrollment fee</span>

              <span style={styles.dot}>•</span>

              <span>$1,299 value*</span>
            </div>

            

           <p style={styles.subtitle}>
        Your complimentary 12 months of access to Thrive Signature 
        <br />
       benefits starts here.
        </p>

          

            {/* <div style={styles.divider} />

            <Benefit
              img={gift}
              title="$1,500 Welcome Bonus"
              desc="Issued in Thrive Rewards Points* within 3–5 business days after enrollment is approved and complete."
            /> */}

            <div style={styles.divider} />

           <Benefit
              img={steel}
              title="Thrive Signature Benefits"
              desc={
                <>
                  Preferred pricing, shipping included on orders $249+,
                  <br />
                  service and repair savings, and more!
                  <br />
                   <span style={styles.smallText}>
                    $6,597+ in average annual savings.*
                  </span>
                </>
              }
            />

            <div style={styles.divider} />

           <Benefit
            img={chart}
            title="Earn Rewards as You Grow"
            desc={
              <>
                Earn $500 in Thrive Rewards points for every $5,000 you spend!{" "}<br />
                <span style={{ fontSize: "11px" }}>
                  (up to $10,500*)
                </span>
              </>
            }
          />

            <div style={styles.divider} />

            <div style={styles.sectionTitle}>
            Confirm Your Account
            </div>

            {/* FORM */}
            <div style={styles.form}>

            
              <div style={styles.formTitle}>
              Enter your Henry Schein account number to activate your offer.<br /> <span style={{fontSize:"11px",color: "#0E176D",}}>(Find it on any invoice or order confirmation.) </span>
              </div>

                          <label style={styles.label}>
              Henry Schein Account Number{" "}
              <span style={{ color: "red" }}>*</span>
            </label>

            <input
              placeholder="Location Account Number"
              style={styles.input}
              value={shipto}
              type="text"
              inputMode="numeric"
              onChange={(e) => {
                const value = e.target.value;

                // allow only numbers
                if (/^\d*$/.test(value)) {
                  setShipto(value);
                }
              }}
            />

                <button
                  style={{
                    ...styles.button,
                    opacity: loading ? 0.7 : 1,
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                  onClick={handleSearch}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Activate My Benefits → "}
                </button>

              <div style={styles.secure}>
             🔒 Your information is secure. To view Henry Schein's Privacy Statement,{" "}
               <a
        href="https://www.henryschein.com/en-us/privacy-statement"
        target="_blank"
        rel="noopener noreferrer"
        
      >
       Click here.
      </a>
                
              
            </div>
            </div>
          </div>

          {/* OFFER DETAILS */}
          <div
            style={styles.toggle}
            onClick={() => setShowDetails(!showDetails)}
          >
            <div style={styles.offerSection}>
              <InfoOutlinedIcon style={styles.infoIcon} />

              <div>
                <div style={styles.toggleText}>
                  {showDetails
                    ? "Hide Offer Details"
                    : "Offer Details"}
                </div>

                {!showDetails && (
                  <div style={styles.offerSubText}>
                    Program details, rewards information and important terms.
                  </div>
                )}
              </div>
            </div>

            <span style={styles.arrow}>
              {showDetails ? "▲" : "▼"}
            </span>
          </div>

          {/* DESKTOP DETAILS */}
          {showDetails && (
  <div style={styles.dropdownContainer}>
    

    <DetailCard
  title="Program Details"
  items={[
    "This offer is available to select customers and is subject to review and approval.",

    "Select Thrive Signature benefits become available once your enrollment is approved and complete.",

    <span>
      Additional premium Thrive Signature benefits become available after reaching $500
      <Tooltip
        arrow
        placement="top"
        enterTouchDelay={0}
        leaveTouchDelay={3000}
        disableFocusListener
        title={
              <div style={styles.tooltip}>
                As part of this program, the rebate earned by this spend will
                be automatically used towards the discounted Thrive Signature
                fee.
              </div>
            }
      >
        <InfoOutlinedIcon
          style={{
            color: "#0A72BA",
            fontSize: 15,
            cursor: "pointer",
            verticalAlign: "middle",
            marginBottom:"4px"
          }}
        />
      </Tooltip>{" "}
      in qualifying invoiced merchandise spend, including Henry Schein Analysis, Henry Schein Revenue Analysis, Preventive Maintenance Sterilizer Rental, and Thrive Education.
    </span>,
  ]}
/>

    <DetailCard
      title="Earning Growth Bonus Points"
      items={[
        "Earn $500 in Thrive Rewards Growth Bonus Points for every $5,000 in qualifying invoiced merchandise spend, beginning at $10,000 and up to $110,000.",
        "Exclusions apply, including OraPharma (Arestin), Colgate products, small equipment, handpieces, pharmaceuticals, refurbished equipment, service-related fees, and other non-qualifying items."
      ]}
    />

    <DetailCard
      title="Additional Details"
      items={[
        "Points are non-transferable and have no cash value.",
        "Points may be redeemed for up to 50% of the cost of eligible products on invoices posted within 90 days before redemption.",
        "Points expire at the close of the fiscal period, 24 fiscal months after they are earned. Check your Thrive Rewards Dashboard for exact expiration dates.",
       <>
        Review the{" "}

        <a
        href={termlink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "underline" }}
      >
        Thrive Unlocked Service Agreement
      </a>{" "}
        and the{" "}

      <a
        href="https://www.henryschein.com/en-us/about/thrive/terms-and-conditions"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "underline" }}
      >
        Thrive Rewards Terms
      </a>{" "}
      for details.
    </>,
      ]}
    />
  </div>
)}
        </div>
      </div>
    </>
  );
}

/* BENEFIT */
const Benefit = ({ img, title, desc }) => (
  <div style={styles.benefitRow}>
    <img src={img} alt="benefit" style={styles.benefitImage} />

    <div>
      <div style={styles.benefitTitle}>{title}</div>

      <div style={styles.benefitDesc}>{desc}</div>
    </div>
  </div>
);

/* DESKTOP COLUMN */
const DetailColumn = ({ title, items }) => (
  <div style={styles.column}>
    <div style={styles.columnTitle}>{title}</div>

    <ul style={styles.ul}>
      {items.map((i, idx) => (
        <li key={idx}>{i}</li>
      ))}
    </ul>
  </div>
);

/* MOBILE CARD */
const DetailCard = ({ title, items }) => (
  <div style={styles.mobileCard}>
    <div style={styles.mobileCardTitle}>{title}</div>

    <ul style={styles.mobileUl}>
      {items.map((i, idx) => (
        <li key={idx}>{i}</li>
      ))}
    </ul>
  </div>
);

const styles = {
  page: {
  background: "#eef1f5",
  minHeight: "100vh",
  margin: 0,
  padding: "16px",
  fontFamily: "Arial, sans-serif",
  overflowX: "hidden",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
},

  fullHeader: {
  width: "100%",
  maxWidth: "520px",
  background: "#fff",
  padding: "10px 16px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  margin: "0 auto 20px auto",
  boxSizing: "border-box",
  borderRadius: "10px",
},

  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
  },

  logo: {
    width: "120px",
    maxWidth: "40%",
    objectFit: "contain",
  },

  rightLogo: {
    width: "180px",
    maxWidth: "52%",
    objectFit: "contain",
  },

  card: {
    width: "100%",
    maxWidth: "520px",
    margin: "0 auto",
    background: "#fff",
    borderRadius: "14px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
    overflow: "hidden",
  },

  cardHeader: {
    background: "#0A72BA",
    textAlign: "center",
    // padding: "12px",
  },

  unlockLogo: {
    width: "100%",
    maxWidth: "250px",
    objectFit: "contain",
  },

  content: {
    padding: "20px",
    boxSizing: "border-box",
  },

  iconCircle: {
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    background: "#e6f0ff",
    display: "block",
    margin: "0 auto 14px",
    padding: "12px",
    objectFit: "contain",
  },

  title: {
    textAlign: "center",
    color: "#1d2b53",
    fontSize: "30px",
    lineHeight: "36px",
    marginBottom: "10px",
  },

  subtitle: {
    textAlign: "center",
    fontSize: "14px",
    lineHeight: "22px",
    color: "#343F88",
    marginBottom: "18px",
  },

  divider: {
    height: "1px",
    background: "#e5e7eb",
    margin: "14px 0",
  },

  benefitRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  benefitImage: {
    width: "44px",
    height: "44px",
    borderRadius: "12px",
    background: "#eef3fb",
    padding: "6px",
    objectFit: "contain",
    flexShrink: 0,
  },

  benefitTitle: {
    color: "#1f5fbf",
    fontWeight: "bold",
    fontSize: "15px",
    marginBottom: "4px",
  },

  benefitDesc: {
    fontSize: "13px",
    lineHeight: "18px",
    color: "#343F88",
  },

  form: {
    marginTop: "4px",
  },

  formTitle: {
    fontWeight: "400",
    color: "#0E176D",
    marginBottom: "9px",
    fontSize: "12px",
  },

  label: {
    fontSize: "12px",
    fontWeight: "bold",
    color: "#0E176D",
    display: "block",
    marginBottom: "6px",
  },

  input: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    marginBottom: "10px",
    fontSize: "14px",
    boxSizing: "border-box",
  },

  button: {
    width: "100%",
    padding: "14px",
    background: "#11999f",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "15px",
    marginTop: "8px",
  },

  secure: {
    fontSize: "11px",
    lineHeight: "18px",
    color: "#6b7280",
    marginTop: "10px",
    marginLeft:"10px"
  },

  toggle: {
    background: "#F6F9FD",
    padding: "14px 18px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    cursor: "pointer",
    gap: "10px",
  },

  offerSection: {
    display: "flex",
    gap: "10px",
    flex: 1,
  },

  infoIcon: {
    color: "#1f5fbf",
    fontSize: "24px",
    marginTop: "2px",
  },

  toggleText: {
    color: "#1f5fbf",
    fontWeight: "600",
    fontSize: "15px",
  },

  offerSubText: {
    color: "#6b7280",
    fontSize: "12px",
    marginTop: "4px",
    lineHeight: "18px",
  },

  arrow: {
    fontSize: "12px",
    color: "#1f5fbf",
    marginTop: "6px",
  },

  details: {
    display: "flex",
    background: "#F6F9FD",
    padding: "20px",
    gap: "16px",
  },

  column: {
    flex: 1,
  },

  columnTitle: {
    fontWeight: "bold",
    marginBottom: "10px",
    color: "#1f5fbf",
    fontSize: "15px",
  },

  ul: {
    paddingLeft: "18px",
    lineHeight: "1.7",
    color: "#343F88",
    fontSize: "13px",
  },

  mobileCard: {
    background: "#fff",
    borderRadius: "14px",
    padding: "16px",
    border: "1px solid #e5e7eb",
  },

  mobileCardTitle: {
    color: "#1f5fbf",
    fontWeight: "700",
    marginBottom: "10px",
    fontSize: "16px",
  },

  mobileUl: {
    paddingLeft: "18px",
    lineHeight: "1.7",
    color: "#343F88",
    fontSize: "13px",
  },

  sectionTitle: {
    // marginTop: "5px",
    fontWeight: "bold",
    color: "#0E176D",
  },

  dropdownContainer: {
  display: "flex",
  flexDirection: "column",
  gap: "14px",
  padding: "16px",
  background: "#F6F9FD",
},
   tooltip: {
    backgroundColor: "#FFFFFF",
    color: "#343F88",
    border: "1px solid #ffffff",
    borderRadius: "8px",
    padding: "12px",
    fontSize: "13px",
    lineHeight: "20px",
  },

    valueText: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    color: "#0E176D",
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: "700",
    marginBottom: "18px",
  },

  dot: {
    fontSize: "18px",
    fontWeight: "700",
  },

   smallText: {
    fontSize: "11px",
    lineHeight: "20px",
    color: "#343F88",
  },

  
};

const mobileCss = `
*{
  box-sizing:border-box;
}

.desktop-details{
  display:flex;
}

.mobile-details{
  display:none;
}

.MuiTooltip-tooltip {
  background: #FFFFFF !important;
  color: #343F88 !important;
  border: 1px solid #D9D9D9 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;
  font-size: 13px !important;
}

.MuiTooltip-arrow {
  color: #FFFFFF !important;
}

@media only screen and (max-width:768px){

  .desktop-details{
    display:none !important;
  }

  .mobile-details{
    display:flex !important;
    flex-direction:column;
    gap:14px;
    padding:16px;
    background:#F6F9FD;
  }

  .headerContent{
    flex-direction:column !important;
    align-items:center !important;
  }
}

@media only screen and (max-width:480px){

  h2{
    font-size:24px !important;
    line-height:32px !important;
  }

  input{
    font-size:16px !important;
  }

  button{
    font-size:15px !important;
  }
}
`;